import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Rails from '@rails/ujs';

import axios from 'axios';

window.Swal = Swal;

// Behavior after click to confirm button
const confirmed = (element, result) => {
  if (result.value) {
    if (!!element.getAttribute('data-remote')) {
      let reloadAfterSuccess = !!element.getAttribute('data-reload');

      axios({
        method: element.getAttribute('data-method') || 'GET',
        url: element.getAttribute('href'),
        dataType: 'json',
      }).then(result => {
        Swal.fire({ title: '', text: (result.data && result.data.message) || '', icon: 'success' })
            .then((_result) => {
              if (reloadAfterSuccess) {
                window.location.reload();
              }
        });
      }).catch(error => {
        let title = 'Error!';
        let message = 'Something went wrong. Please try again later.';

        if (error.responseJSON && error.responseJSON.message) {
          message = error.responseJSON.message;
        }

        Swal.fire(title, message, 'error');
      });

    } else {
      element.removeAttribute('data-confirm-swal');
      element.click();
    }
  }
};

// Display the confirmation dialog
const showConfirmationDialog = (element) => {
  const message = element.getAttribute('data-confirm-swal');
  const title = element.getAttribute('data-title-swal');
  const okButton = element.getAttribute('data-ok-button');
  const cancelButton = element.getAttribute('data-cancel-button');

  const swalWithSubmitCustomId = Swal.mixin({
    didOpen: () => {
      Swal.getConfirmButton().setAttribute('id', 'send-benchmarking-results');
    }
  });

  swalWithSubmitCustomId.fire({
    title: title || '',
    text: message || '',
    icon: 'info',
    iconColor: '#2d3748',
    color: '#2d3748',
    showCancelButton: true,
    confirmButtonText: okButton || 'Yes',
    cancelButtonText: cancelButton || 'Cancel',
  }).then(result => confirmed(element, result));
};

const allowAction = (element) => {
  if (element.getAttribute('data-confirm-swal') === null) {
    return true;
  }

  showConfirmationDialog(element);
  return false;
};

function handleConfirm(element) {
  if (!allowAction(this)) {
    Rails.stopEverything(element);
  }
}

Rails.delegate(document, 'a[data-confirm-swal]', 'click', handleConfirm);
